import { Component } from '@angular/core';

@Component({
  selector: 'k-spinner',
  templateUrl: './k-spinner.component.html',
  styleUrls: ['./k-spinner.component.scss']
})
export class KSpinnerComponent {
  // opacity: number[];
  steps: number[] = [];
  numberOfItem: number = 100;

  constructor() {
    let step = 1 / this.numberOfItem;
    step = Math.round(step * 100) / 100;
    for (let i = 0; i < this.numberOfItem; i++) {
      if (i === 0) this.steps.push(step);
      if (i > 0) {
        let val = Math.round((this.steps[i - 1] + step) * 100) / 100;
        this.steps.push(val);
      }
    };
  }

}



